import React, { useState, useEffect, useRef } from "react";
import { IoIosSend } from "react-icons/io";
import { AiOutlinePaperClip } from "react-icons/ai";
import InputField from "../atoms/InputField";
import Button from "../atoms/Button";
import "../../static/css/ChatWindow.css";
import { useChatContext } from "../../../context/ChatContext";
import Spinner from "../atoms/Spinner";
import { service } from "../../../services/AxiosServices";
import AI_spaceicon from "../../static/svg/AI_spaceicon";
import Artificiallidiscription from "../../static/svg/Artificiallidiscription";
import Userdummy from "../../static/svg/Userdummy";
import TextArea from "../atoms/TextArea";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import TypingIndicator from "../atoms/TypingIndicator";
import { useTheme } from "../../../context/ThemeContext";
import SettingDarkmodeIcon from "../../static/svg/SettingDarkmodeIcon";
import Backicon from "../../static/svg/Backicon";
import SpaceLogo from "../../static/svg/SpaceLogo";
import InfanionLogo from "../../static/svg/InfanionLogo";
import SendIcon from "../../static/svg/SendIcon";
import { useNavigate } from "react-router-dom";
import NewChart from "../../static/svg/NewChart";
import QuestionAIIcon from "../../static/images/QuestionAIIcon.png";
import CopyIcon from "../../static/svg/CopyIcon";
import ThumbsDownIcon from "../../static/svg/ThumbsDownIcon";
import ThumbsupIcon from "../../static/svg/ThumbsupIcon";
import DarkBackIcon from "../../static/svg/DarkBackIcon";
import ReactMarkdown from "react-markdown";
import { toast } from "react-toastify";

interface ModelResponse {
  model_name: string;
  response: string;
}

interface Task {
  id: number;
  task_description: string;
  response: ModelResponse[];
  section_id?: string;
  selectedModels?: number[];
  streaming?: boolean;
  partialResponses?: { [key: string]: string };
}
type ChatHistoryEntry = {
  id: string;
  desc: string;
};

interface Props {
  Id: string;
  spaceChat: boolean;
  toggle: boolean;
  setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChatWindow: React.FC<Props> = ({ Id, spaceChat, toggle, setToggle }) => {
  const {
    chats,
    setChats,
    setChatHistory,
    chatHistory,
    currentSectionId,
    setCurrentSectionId,
    chatStates,
    setChatStates,
    isProcessingRequest,
    setIsProcessingRequest,
  } = useChatContext();

  const [input, setInput] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [isNewChat, setIsNewChat] = useState(true);
  const [loading, setLoading] = useState(false);
  const [pendingMessage, setPendingMessage] = useState<string | null>(null);
  const { isDarkMode, toggleTheme } = useTheme();
  const [selectedLLMs, setSelectedLLMs] = useState<number[]>([]);
  const [feedback, setFeedback] = useState(0);
  const [thumbsDown, setThumbsDown] = useState(false);
  const [placeholder, setPlaceholder] = useState("Type your text here");
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [showFeedback, setShowFeedback] = useState<string | null>(null);
  const [thumbsfeedback, setthumbsfeedback] = useState("");

  const [streamingResponses, setStreamingResponses] = useState<{
    [key: string]: boolean;
  }>({});
  const streamIntervalRef = useRef<{ [key: string]: NodeJS.Timeout }>({});
  const simulateStreaming = (
    response: string,
    taskId: number,
    modelIndex: number
  ) => {
    const streamKey = `${taskId}-${modelIndex}`;

    // Initialize if this is a new streaming response
    if (!streamingResponses[streamKey]) {
      setStreamingResponses((prev) => ({ ...prev, [streamKey]: true }));

      // Start with an empty string for this response
      setChats((prevChats) => {
        return prevChats.map((chat) => {
          if (chat.id === taskId) {
            const newChat = { ...chat };
            if (!newChat.partialResponses) {
              newChat.partialResponses = {};
            }
            newChat.partialResponses[modelIndex] = "";
            newChat.streaming = true;
            return newChat;
          }
          return chat;
        });
      });

      // Set up the interval to add characters gradually
      let charIndex = 0;
      const fullResponse = response;
      const typingSpeed = Math.floor(Math.random() * 20) + 10; // Random speed between 10-30ms for natural feel

      streamIntervalRef.current[streamKey] = setInterval(() => {
        if (charIndex < fullResponse.length) {
          // Adding several characters at once feels more natural than one by one
          const chunkSize = Math.floor(Math.random() * 3) + 1; // 1-3 characters at a time
          const nextIndex = Math.min(
            charIndex + chunkSize,
            fullResponse.length
          );
          const nextChunk = fullResponse.substring(charIndex, nextIndex);
          charIndex = nextIndex;

          setChats((prevChats) => {
            return prevChats.map((chat) => {
              if (chat.id === taskId) {
                const newChat = { ...chat };
                if (!newChat.partialResponses) {
                  newChat.partialResponses = {};
                }
                newChat.partialResponses[modelIndex] =
                  (newChat.partialResponses[modelIndex] || "") + nextChunk;
                return newChat;
              }
              return chat;
            });
          });
        } else {
          // End of response reached
          clearInterval(streamIntervalRef.current[streamKey]);
          delete streamIntervalRef.current[streamKey];

          // Mark streaming as complete for this response
          setStreamingResponses((prev) => {
            const newState = { ...prev };
            delete newState[streamKey];
            return newState;
          });

          // Update the final state
          setChats((prevChats) => {
            return prevChats.map((chat) => {
              if (chat.id === taskId) {
                const newChat = { ...chat };
                // Check if all responses have finished streaming
                const hasActiveStreams = Object.keys(streamingResponses).some(
                  (key) => key.startsWith(`${taskId}-`)
                );

                if (!hasActiveStreams) {
                  newChat.streaming = false;
                }
                return newChat;
              }
              return chat;
            });
          });
        }
      }, typingSpeed);
    }
  };
  const [isAtBottom, setIsAtBottom] = useState(true);

  const navigate = useNavigate();
  const chatDisplayRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (chatDisplayRef.current && isAtBottom) {
      chatDisplayRef.current.scrollTop = chatDisplayRef.current.scrollHeight;
    }
  };

  // Add scroll event listener
  useEffect(() => {
    const chatDisplay = chatDisplayRef.current;
    if (chatDisplay) {
      const handleScroll = () => {
        const isScrolledToBottom =
          chatDisplay.scrollHeight - chatDisplay.clientHeight <=
          chatDisplay.scrollTop + 50;
        setIsAtBottom(isScrolledToBottom);
      };

      chatDisplay.addEventListener("scroll", handleScroll);
      return () => chatDisplay.removeEventListener("scroll", handleScroll);
    }
  }, []);
  // Auto-scroll when new messages arrive
  useEffect(() => {
    scrollToBottom();
  }, [chats, pendingMessage]);

  useEffect(() => {
    // When the currentSectionId changes (navigating to a different chat),
    // reset the feedback UI state
    setShowFeedback(null);
    setthumbsfeedback("");
  }, [currentSectionId]);
  // Load chat state when currentSectionId changes
  useEffect(() => {
    if (currentSectionId && chatStates[currentSectionId]) {
      const savedState = chatStates[currentSectionId];
      setInput(savedState.input || "");
      setPendingMessage(savedState.pendingMessage || null);
      setLoading(savedState.isLoading || false);
      setSelectedLLMs(savedState.selectedLLMs || []);
      setFeedback(savedState.feedback || 0);
      setIsNewChat(false);
      // Reset feedback state when switching chats
      setShowFeedback(null);
      setthumbsfeedback("");
    } else if (currentSectionId) {
      // Reset for new section with ID but no saved state
      setInput("");
      setPendingMessage(null);
      setLoading(false);
      setSelectedLLMs([]);
      setFeedback(0);
      setIsNewChat(false);
    } else {
      // Reset for completely new chat
      setInput("");
      setPendingMessage(null);
      setLoading(false);
      setSelectedLLMs([]);
      setFeedback(0);
      setIsNewChat(true);
      setShowFeedback(null);
      setthumbsfeedback("");
      setShowFeedback(null);
      setthumbsfeedback("");
    }
  }, [currentSectionId, chatStates]);

  // Save current chat state when component unmounts or before switching sections
  const saveCurrentState = () => {
    if (currentSectionId) {
      setChatStates((prev) => ({
        ...prev,
        [currentSectionId]: {
          input,
          pendingMessage,
          isLoading: loading,
          selectedLLMs,
          feedback,
        },
      }));
    }
  };

  // chats changes to update currentSectionId
  useEffect(() => {
    if (chats.length > 0 && chats[0].section_id) {
      // Only update if ID changes - prevents overwriting state during updates
      if (currentSectionId !== chats[0].section_id) {
        saveCurrentState();
        setCurrentSectionId(chats[0].section_id);
      }
    }
  }, [chats]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };
  const handleModelSelection = (
    e: React.ChangeEvent<HTMLInputElement>,
    modelId: number,
    taskId: number // Add the taskId parameter
  ) => {
    const modelIdNum = Number(modelId);

    setChats((prevChats) => {
      return prevChats.map((chat) => {
        // Only update the specific task
        if (chat.id === taskId) {
          const selectedModels = chat.selectedModels || [];

          if (e.target.checked) {
            // Add model to selection if checked
            return {
              ...chat,
              selectedModels: [...selectedModels, modelIdNum],
            };
          } else {
            // Remove model from selection if unchecked
            return {
              ...chat,
              selectedModels: selectedModels.filter((id) => id !== modelIdNum),
            };
          }
        }
        return chat;
      });
    });

    // If this is the latest response, also update the global feedback state
    if (taskId === chats[chats.length - 1]?.id) {
      if (e.target.checked) {
        setFeedback(1);
      } else {
        // Check if there are any models selected in the latest response
        const latestChat = chats[chats.length - 1];
        const selectedModels = latestChat?.selectedModels || [];
        const willBeEmpty =
          selectedModels.length <= 1 && selectedModels.includes(modelIdNum);

        if (willBeEmpty) {
          setFeedback(0);
        }
      }
    }
  };
  const handleNewChat = () => {
    // Save current state before creating new chat
    saveCurrentState();

    // Reset all the states for a new chat
    setChats([]);
    setCurrentSectionId(null);
    setIsNewChat(true);
    setInput("");
    setPendingMessage(null);
    setLoading(false);
    setIsProcessingRequest(false);
    setThumbsDown(false);
    setPlaceholder("Type your text here");
  };

  const handleSubmit = async () => {
    if (!input.trim() && !file) return;
    if (isProcessingRequest) return; // Prevent multiple submissions

    const currentInput = input;
    setIsProcessingRequest(true);
    setPendingMessage(currentInput);

    const requestSectionId = currentSectionId;
    const latestChat = chats[chats.length - 1];
    const selectedModelsForRequest = latestChat?.selectedModels || [];
    try {
      setLoading(true);

      const endPoint = spaceChat ? "/api/ai-space-search" : "/api/spacesearch";

      const requestBody: Record<string, any> = {
        ...(spaceChat ? { space_id: Id } : { crew: Id }),
        project_id: localStorage.getItem("project_id"),
        content: currentInput,
        user_id: localStorage.getItem("user"),
        // Only include section_id if it's not a new chat
        ...(isNewChat ? {} : { section_id: requestSectionId }),
      };

      // Conditionally include llms and feedback

      if (selectedModelsForRequest.length > 0) {
        requestBody.llm = selectedModelsForRequest
          .map((id) => id.toString())
          .join(",");
        requestBody.feedback = "1";
      }

      console.log("chat request", requestBody);

      // Clear input immediately after sending
      setInput("");
      setFile(null);

      const response = await service<any>(endPoint, "post", requestBody);

      // Only update if we're still in the same section or if this is a new chat
      if (
        (requestSectionId === null && isNewChat) ||
        (requestSectionId && requestSectionId === currentSectionId)
      ) {
        if (response.data.sections.length > 0) {
          const responseSectionId = response.data.sections[0].id;

          // Set the current section ID from the response
          if (isNewChat) {
            setCurrentSectionId(responseSectionId);
            setIsNewChat(false);
          }
          // In the response handler after new chats are created:
          const newChats = response.data.sections.flatMap((section: any) =>
            section.tasks.map((task: any) => ({
              id: task.id,
              task_description: task.task_description,
              response: task.response,
              section_id: section.id,
              selectedModels: [],
              streaming: true, // Mark as streaming initially
              partialResponses: {}, //
            }))
          );

          newChats.sort((a: Task, b: Task) => a.id - b.id);

          // If it's a new chat, replace the chats array; otherwise, append
          if (isNewChat) {
            setChats(newChats);

            // Only add to history if it's a new chat
            if (newChats.length > 0) {
              const newEntry = {
                id: String(responseSectionId),
                desc: newChats[0].task_description,
              };

              if (!chatHistory.some((entry) => entry.id === newEntry.id)) {
                setChatHistory((prevHistory) => [newEntry, ...prevHistory]);
              }
            }
            newChats.forEach((chat: Task) => {
              chat.response?.forEach((resp, idx) => {
                if (resp.response && resp.response.trim() !== "") {
                  simulateStreaming(resp.response, chat.id, idx);
                }
              });
            });
          } else {
            setChats((prevChats) => {
              // Create a new array with only unique entries
              const combinedChats = [...prevChats];

              // Only add new chats and stream them
              newChats.forEach((newChat: Task) => {
                if (!combinedChats.some((chat) => chat.id === newChat.id)) {
                  combinedChats.push(newChat);

                  // Stream only newly added chat responses
                  newChat.response?.forEach((resp, idx) => {
                    if (resp.response && resp.response.trim() !== "") {
                      simulateStreaming(resp.response, newChat.id, idx);
                    }
                  });
                }
              });

              return combinedChats.sort((a, b) => a.id - b.id);
            });
          }
        }
      } else {
        // If we've switched to a new section, update that section's data in chatStates
        if (response.data.sections.length > 0) {
          const responseSectionId = response.data.sections[0].id;

          const newChats = response.data.sections.flatMap((section: any) =>
            section.tasks.map((task: any) => ({
              id: task.id,
              task_description: task.task_description,
              response: task.response,
              section_id: section.id,
            }))
          );

          // Add this data to chatStates for when user returns to this section
          setChatStates((prev) => {
            const existingChats = prev[responseSectionId]?.chats || [];
            return {
              ...prev,
              [responseSectionId]: {
                ...prev[responseSectionId],
                input: "",
                pendingMessage: null,
                isLoading: false,
                chats: newChats,
              },
            };
          });

          // Update chat history if needed
          if (isNewChat && newChats.length > 0) {
            const newEntry = {
              id: String(responseSectionId),
              desc: newChats[0].task_description,
            };

            if (!chatHistory.some((entry) => entry.id === newEntry.id)) {
              setChatHistory((prevHistory) => [newEntry, ...prevHistory]);
            }
          }
        }
      }

      setPendingMessage(null);
      if (thumbsDown) {
        setThumbsDown(false);
        setPlaceholder("Type your text here");
      }
    } catch (err) {
      console.error("Error in handleSubmit:", err);
      setPendingMessage(null);
    } finally {
      // Always update the loading state in context
      setLoading(false);
      setIsProcessingRequest(false);

      // Update the state in chatStates for this section
      if (requestSectionId) {
        setChatStates((prev) => ({
          ...prev,
          [requestSectionId]: {
            ...prev[requestSectionId],
            input: "",
            pendingMessage: null,
            isLoading: false,
          },
        }));
      }
    }
  };

  const handleThumbsUp = async (e:React.MouseEvent<HTMLElement>,taskId: number, modelId: number) => {
    e.stopPropagation()
    try {
      const endPoint = spaceChat ? "/api/ai-space-search" : "/api/spacesearch";

      const requestBody: Record<string, any> = {
        task_id: taskId,
        ...(spaceChat ? { space_id: Id } : { crew: Id }),
        project_id: localStorage.getItem("project_id"),
        thumbsup: "True",
        selected_llm: String(modelId),
        user_id: localStorage.getItem("user"),
      };
      await service<any>(endPoint, "post", requestBody);
      toast.success("Thanks for the response", {
        autoClose: 2000,
      });
    } catch (err) { }
  };
  const handleCopy = async (e:React.MouseEvent<HTMLElement>,text: string) => {
    e.stopPropagation()
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success("Text copied to clipboard!", {
          autoClose: 2000,
        });
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        toast.error("Failed to copy text", {
          autoClose: 2000,
        });
      });
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (e.key === "Enter" && !e.shiftKey && (input.trim() || file)) {
      e.preventDefault();
      handleSubmit();
    }
  };
  const handleFeedbackKeyDown = (
    e: React.KeyboardEvent<HTMLTextAreaElement>
  ) => {
    if (e.key === "Enter" && !e.shiftKey && thumbsfeedback.trim()) {
      e.preventDefault();
      thumbhandleSubmit();
    }
  };

  // const FeedbackComponent = () => {

  const handleThumbsDownClick = async (e:React.MouseEvent<HTMLElement>,taskId: number, modelIndex: number) => {
    e.stopPropagation()
    const feedbackId = `${taskId}-${modelIndex}`;

    setShowFeedback((prevId) => (prevId === feedbackId ? null : feedbackId));
  };

  const thumbhandleSubmit = async () => {

    if (isProcessingRequest) return; // Prevent multiple submissions

    // If user hasn't entered feedback yet, just return
    if (!thumbsfeedback.trim()) return;

    const currentInput = thumbsfeedback; // Use thumbsfeedback instead of input
    setIsProcessingRequest(true);
    setPendingMessage(currentInput);

    // local reference to this request's sectionId
    const requestSectionId = currentSectionId;
    const latestChat = chats[chats.length - 1];
    const selectedModelsForRequest = latestChat?.selectedModels || [];


    try {
      setLoading(true);

      const endPoint = spaceChat ? "/api/ai-space-search" : "/api/spacesearch";

      const requestBody: Record<string, any> = {
        ...(spaceChat ? { space_id: Id } : { crew: Id }),
        project_id: localStorage.getItem("project_id"),
        content: currentInput,
        user_id: localStorage.getItem("user"),
        // Only include section_id if it's not a new chat
        ...(isNewChat ? {} : { section_id: requestSectionId }),
        // Always include feedback for thumbs down
        feedback: "1",
      };
      if (selectedModelsForRequest.length > 0) {
        requestBody.llm = selectedModelsForRequest
          .map((id) => id.toString())
          .join(",");
      }

      console.log("feedback request", requestBody);

      const response = await service<any>(endPoint, "post", requestBody);
      if (
        (requestSectionId === null && isNewChat) ||
        (requestSectionId && requestSectionId === currentSectionId)
      ) {
        if (response.data.sections.length > 0) {
          const responseSectionId = response.data.sections[0].id;

          // Set the current section ID from the response
          if (isNewChat) {
            setCurrentSectionId(responseSectionId);
            setIsNewChat(false);
          }
          // In the response handler after new chats are created:
          const newChats = response.data.sections.flatMap((section: any) =>
            section.tasks.map((task: any) => ({
              id: task.id,
              task_description: task.task_description,
              response: task.response,
              section_id: section.id,
              selectedModels: [],
              streaming: true,
              partialResponses: {}, //
            }))
          );

          newChats.sort((a: Task, b: Task) => a.id - b.id);

          // If it's a new chat, replace the chats array; otherwise, append
          if (isNewChat) {
            setChats(newChats);

            // Only add to history if it's a new chat
            if (newChats.length > 0) {
              const newEntry = {
                id: String(responseSectionId),
                desc: newChats[0].task_description,
              };

              if (!chatHistory.some((entry) => entry.id === newEntry.id)) {
                setChatHistory((prevHistory) => [newEntry, ...prevHistory]);
              }
            }
            newChats.forEach((chat: Task) => {
              chat.response?.forEach((resp, idx) => {
                if (resp.response && resp.response.trim() !== "") {
                  simulateStreaming(resp.response, chat.id, idx);
                }
              });
            });
          } else {
            setChats((prevChats) => {
              // Create a new array with only unique entries
              const combinedChats = [...prevChats];

              // Only add new chats and stream them
              newChats.forEach((newChat: Task) => {
                if (!combinedChats.some((chat) => chat.id === newChat.id)) {
                  combinedChats.push(newChat);

                  // Stream only newly added chat responses
                  newChat.response?.forEach((resp, idx) => {
                    if (resp.response && resp.response.trim() !== "") {
                      simulateStreaming(resp.response, newChat.id, idx);
                    }
                  });
                }
              });

              return combinedChats.sort((a, b) => a.id - b.id);
            });
          }
        }
      } else {
        // If we've switched to a new section, update that section's data in chatStates
        if (response.data.sections.length > 0) {
          const responseSectionId = response.data.sections[0].id;

          const newChats = response.data.sections.flatMap((section: any) =>
            section.tasks.map((task: any) => ({
              id: task.id,
              task_description: task.task_description,
              response: task.response,
              section_id: section.id,
            }))
          );

          // Add this data to chatStates for when user returns to this section
          setChatStates((prev) => {
            const existingChats = prev[responseSectionId]?.chats || [];
            return {
              ...prev,
              [responseSectionId]: {
                ...prev[responseSectionId],
                input: "",
                pendingMessage: null,
                isLoading: false,
                chats: newChats,
              },
            };
          });

          // Update chat history if needed
          if (isNewChat && newChats.length > 0) {
            const newEntry = {
              id: String(responseSectionId),
              desc: newChats[0].task_description,
            };

            if (!chatHistory.some((entry) => entry.id === newEntry.id)) {
              setChatHistory((prevHistory) => [newEntry, ...prevHistory]);
            }
          }
        }
      }

      setPendingMessage(null);

      setthumbsfeedback("");
      setShowFeedback(null);
    } catch (err) {
      console.error("Error in thumbhandleSubmit:", err);
      setPendingMessage(null);
    } finally {
      // Always update the loading state in context
      setLoading(false);
      setIsProcessingRequest(false);

      // Close the feedback field
      setShowFeedback(null);
      setthumbsfeedback("");

      // Update the state in chatStates for this section
      if (requestSectionId) {
        setChatStates((prev) => ({
          ...prev,
          [requestSectionId]: {
            ...prev[requestSectionId],
            input: "",
            pendingMessage: null,
            isLoading: false,
          },
        }));
      }
    }
  };

  const storedUser = localStorage.getItem("user_account");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const firstName = user?.first_name || "Admin";

  useEffect(() => {
    return () => {
      // Clear all streaming intervals
      Object.values(streamIntervalRef.current).forEach((interval) => {
        clearInterval(interval);
      });
      // Save all chat states when component unmounts
      saveCurrentState();
    };
  }, []);

  const handleCheck = (chatId: number, modelId: number) => {
    setChats((prevChats) => {
      return prevChats.map((chat) => {
        if (chat.id === chatId) {
          const selectedModels = chat.selectedModels || [];
          const isSelected = selectedModels.includes(modelId);

          return {
            ...chat,
            selectedModels: isSelected
              ? selectedModels.filter((id) => id !== modelId)
              : [...selectedModels, modelId],
          };
        }
        return chat;
      });
    });


    const latestChat = chats[chats.length - 1];
    if (latestChat && latestChat.id === chatId) {
      setFeedback((prevFeedback) => (prevFeedback === 1 ? 0 : 1));
    }
  };
  console.log(chats);

  return (
    <div
      className={`AI_space_chart ${isDarkMode ? "bg-dark-mode" : "bg-light-mode "
        }`}
    >
      <div className="d-flex align-items-center justify-content-end p-3">
        <div
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
          className="Space_chart_logo"
        >
          {isDarkMode ? (
            <span>
              <InfanionLogo />
            </span>
          ) : (
            <span>
              <SpaceLogo />
            </span>
          )}
        </div>
        <div className="d-flex">
          <span
            style={{ cursor: "pointer" }}
            className="me-3"
            onClick={toggleTheme}
          >
            <SettingDarkmodeIcon />
          </span>
          <span onClick={() => navigate(-1)}>
            <span className="">
              {isDarkMode ? <DarkBackIcon /> : <Backicon />}
            </span>
          </span>
        </div>
      </div>
      <div className="flex-1 overflow-auto">
        <div className="h-100 overflow-auton d-flex flex-column">
          {!toggle && (
            <div
              className={`toggle-container d-flex px-4 ${isDarkMode ? "bg-dark" : ""
                }`}
            >
              <div
                className="me-2"
                role="button"
                tabIndex={0}
                style={{ cursor: "pointer" }}
                onClick={() => setToggle(!toggle)}
              >
                <AI_spaceicon />
              </div>
              <div
                title="New chat"
                data-bs-toggle="tooltip"
                style={{ cursor: "pointer" }}
                onClick={handleNewChat}
              >
                <NewChart />
              </div>
            </div>
          )}

          <div className="chat-window chat-container w-100 m-auto overflow-auto d-flex flex-column flex-grow-1">
            <div
              ref={chatDisplayRef}
              className={`chat-display chat-display overflow-auto ${chats.length !== 0 && "flex-1"
                }`}
            >
              {chats.length === 0 && !pendingMessage ? (
                <div className="welcome-message mt-5 pt-3">
                  <h1>Hello {firstName}</h1>
                  <p>How can I help you today?</p>
                </div>
              ) : (
                <ul
                  className="col-11 m-auto chart-content px-5"
                  style={{ listStyle: "none" }}
                >
                  {chats.map((chat) => (
                    <li key={chat.id} className="chat-item">
                      <p className="d-flex align-items-center">
                        <span className="me-3">
                          <img src={QuestionAIIcon} alt="profile" />
                        </span>
                        <div
                          className={`Qustion-block p-3 ${isDarkMode ? "dark-textarea" : ""
                            }`}
                        >
                          {chat.task_description}
                        </div>
                      </p>

                      <div className="responses-grid mb-5">
                        {chat?.response
                          ?.filter(
                            (ele) => ele.response && ele.response.trim() !== ""
                          )
                          .map((ele, index) => {
                            const modelId =
                              ele.model_name === "ChatGPT (gpt-4o)"
                                ? 1
                                : ele.model_name ===
                                  "Claude (claude-3.5-sonnet-20240229-v1:0)"
                                  ? 2
                                  : ele.model_name ===
                                    "Mistral (mixtral-8x7b-instruct-v0:1)"
                                    ? 3
                                    : 0;
                            const feedbackId = `${chat.id}-${index}`;
                            const displayText =
                              chat.streaming &&
                                chat.partialResponses &&
                                chat.partialResponses[index] !== undefined
                                ? chat.partialResponses[index]
                                : ele.response;
                            return (
                              <div
                                key={index}
                                className={`response-card d-flex flex-column cursor-pointer ${isDarkMode ? "dark-textarea" : ""
                                  } ${chat.selectedModels?.includes(index + 1)
                                    ? isDarkMode
                                      ? "selected-dark-bg-color"
                                      : "Selected-bg-color"
                                    : ""
                                  }
                                `}
                              >

                                <div className={"response-content flex-grow-1"} onClick={() => handleCheck(chat.id, modelId)}
                                >
                                  <div
                                    className={`response-header d-flex align-items-start justify-content-between mb-3 ${isDarkMode ? "dark-textarea" : ""
                                      }  ${chat.selectedModels?.includes(index + 1)
                                        ? isDarkMode
                                          ? "selected-dark-bg-color"
                                          : "Selected-bg-color"
                                        : ""
                                      }
                                `}
                                  >
                                    <div
                                      className={`mb-0 
                                      ${isDarkMode ? "model-title-dark" : "model-title-light"} 
                                      ${chat.selectedModels?.includes(index + 1)
                                          ? isDarkMode
                                            ? "selected-dark-bg-color"
                                            : "Selected-bg-color"
                                          : ""
                                        }`}
                                    >
                                      {ele?.model_name}
                                    </div>
                                    <div>
                                      <input
                                        type="checkbox"
                                        name={`modelSelection-${chat.id}-${modelId}`}
                                        className="LLM-checkbox"
                                        value={modelId.toString()}
                                        checked={
                                          chat.selectedModels?.includes(
                                            modelId
                                          ) ?? false
                                        }
                                        onChange={(e) =>
                                          handleModelSelection(
                                            e,
                                            modelId,
                                            chat.id
                                          )
                                        }
                                      />
                                    </div>

                                  </div>
                                  <p className="response-text">
                                    <ReactMarkdown>{displayText}</ReactMarkdown>

                                    {chat.streaming &&
                                      chat.partialResponses &&
                                      chat.partialResponses[index] !==
                                      undefined && (
                                        <span className="typing-cursor">|</span>
                                      )}
                                  </p>
                                </div>
                                <div   onClick={() => handleCheck(chat.id, modelId)}  className="icons d-flex align-items-center justify-content-end mt-auto">
                                  <span
                                    onClick={(e) =>
                                      handleThumbsUp(e,chat.id, modelId)
                                    }
                                    title="Good response"
                                    data-bs-toggle="tooltip"
                                    className={`me-2 cursor-pointer ${isDarkMode ? "ThumbupIcondark" : "ThumbupIcon"
                                      }`}
                                  >
                                    <ThumbsupIcon />
                                  </span>
                                  <span
                                    title="Bad response"
                                    className={`me-2 cursor-pointer Thumbusdown ${showFeedback === `${chat.id}-${index}` ? "active" : ""
                                      } ${isDarkMode ? "Thumbusdowndark" : "Thumbusdown"
                                      }`}
                                    data-bs-toggle="tooltip"
                                    onClick={(e) =>
                                      handleThumbsDownClick(e,chat.id, index)
                                    }
                                  >
                                    <ThumbsDownIcon />
                                  </span>
                                  <span
                                    title="Copy"
                                    data-bs-toggle="tooltip"
                                    className={`me-2 cursor-pointer ${isDarkMode ? "CopyIcondark" : "CopyIcon"
                                      }`}
                                    onClick={(e) => handleCopy(e,ele.response)}
                                  >
                                    <CopyIcon />
                                  </span>
                                </div>
                                {/* Conditionally render the textarea and submit button */}
                                {showFeedback === feedbackId && (
                                  <div className="feedback-popup mt-2 position-relative">
                                    <textarea
                                      className="form-control pe-5"
                                      cols={50}
                                      rows={2}
                                      value={thumbsfeedback}
                                      onKeyDown={handleFeedbackKeyDown}
                                      disabled={isProcessingRequest}
                                      onChange={(e) =>
                                        setthumbsfeedback(e.target.value)
                                      }
                                      placeholder="Enter your feedback..."
                                    ></textarea>
                                    <span
                                      className="Send-feedback"
                                      onClick={thumbhandleSubmit}
                                    >
                                      <SendIcon />
                                    </span>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </li>
                  ))}

                  {/* Pending message with spinner */}
                  {pendingMessage && (
                    <li className="chat-item">
                      <p className="d-flex align-items-center">
                        <span className="me-3">
                          <img src={QuestionAIIcon} alt="profile" />
                        </span>
                        <div
                          className={`Qustion-block p-3 ${isDarkMode ? "dark-textarea" : ""
                            }`}
                        >
                          {pendingMessage}
                        </div>
                      </p>
                      <div className="response-container">
                        <span className="ai-icon"></span>
                        <div className="responses-grid">
                          {loading && <TypingIndicator />}
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              )}
            </div>
            <div className="chat-input chart-content px-5">
              <div
                className="m-auto d-flex align-items-center mb-4"
                style={{
                  width: chats.length === 0 && !pendingMessage ? "50%" : "90%",
                  marginTop:
                    chats.length === 0 && !pendingMessage ? "0px" : "20px",
                }}
              >
                <TextArea
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder={placeholder}
                  rows={2}
                  className={`chat-textarea ${isDarkMode ? "dark-textarea" : ""
                    }`}
                  disabled={isProcessingRequest}
                />

                {(input.trim() || file) && !loading ? (
                  <span
                    className="ms-2 send-icon"
                    role="button"
                    onClick={handleSubmit}
                    style={{
                      cursor: isProcessingRequest ? "not-allowed" : "pointer",
                    }}
                  >
                    <SendIcon />
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatWindow;
